import '@babel/polyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// 哈勃上报
// import '../utils/habo.config';


console.log('看看浏览器ua');
console.log(navigator.userAgent);
